import { makeStyles, css } from '@conexasaude/hero'
import typoMixin from '@/styles/mixins/typo-mixin'

const navbarStyles = makeStyles({
  headerContainer: ({ colors }) => css`
    border-bottom: 1px solid;
    border-bottom-color: ${colors.neutral[100]};
  `,

  navContainer({ colors }) {
    return css`
      position: relative;
      padding: 16px 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      background: ${colors.common.white};
    `
  },
  picNotification: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 639px) {
      .notification-icon {
        display: none !important;
      }
    }
  `,
  navProfile: ({ colors, shadows }) => {
    return css`
      position: relative;
      margin-left: 30px;
      display: flex;
      align-items: center;
      @media (max-width: 639px) {
        margin-left: unset;
        span {
          display: none !important;
        }
      }
      &:hover .suspense-nav {
        display: block;
      }
      .suspense-nav {
        position: absolute;
        width: 100%;
        display: none;
        z-index: 99;
        top: calc(100%);
        padding-top: 8px;

        &.suspense-nav--less {
          top: unset;
          padding-top: 240px;
        }
        &:hover {
          display: block;
        }
        &__container {
          position: relative;
          width: 100%;
          right: 0;
          background-color: ${colors.common.white};
          border-radius: 8px;
          box-shadow: ${shadows};
          padding: 8px 0;
          li {
            padding: 8px 16px;
            cursor: pointer;
            &:hover {
              background-color: ${colors.primary[100]};
              color: ${colors.primary[500]};
            }
          }
          @media (max-width: 639px) {
            width: 150px;
            right: 76px;
          }
        }
      }
    `
  },
  navLogo: css`
    position: relative;
    max-width: 150px;
    max-height: 40px;

    &.conexa-logo {
      max-width: 135px;
    }
  `,
  navContainerBreadcrumb: ({ colors, typography }) => css`
    position: relative;
    padding: 16px 0;
    background-color: ${colors.primary[500]};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    ul {
      display: flex;
      flex-direction: row;

      @media (max-width: 880px) {
        white-space: nowrap;
        gap: 20px;
      }

      .notification {
        &:before {
          content: '';
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 5px;
          background-color: ${colors.secondary[500]};
        }
      }

      @media (max-width: 880px) {
        white-space: nowrap;
        gap: 20px;
      }

      li {
        display: flex;
        margin-right: 50px;
        position: relative;

        align-items: center;

        ${typoMixin({ typography }, 'button3')};
        color: ${colors.common.white};

        @media (max-width: 880px) {
          margin-right: 0;
        }

        a {
          color: ${colors.common.white};
          text-decoration: none;
        }
        &:last-child {
          margin-right: 0;
        }
        &.active {
          a {
            position: relative;
            bottom: 3px;

            &:after {
              content: '';
              position: absolute;
              bottom: -3px;
              left: 0;
              right: 0;
              background: ${colors.secondary[500]};
              height: 4px;
              border-radius: 10px;
            }
          }
        }
        & * {
          margin-right: 10px;
        }
        .support-item-menu {
          background: none;
          border: none;
          ${typoMixin({ typography }, 'button3')};
          color: ${colors.common.white};
          cursor: pointer;
          padding: 0;
        }
      }
    }
    @media (max-width: 880px) {
      overflow-y: hidden;

      ::-webkit-scrollbar {
        display: none;
      }

      ul {
        white-space: nowrap;
        gap: 20px;

        li {
          margin-right: 0;
          .support-item-menu {
            margin-right: 0;
          }
          &.active {
            color: red;
          }
        }
      }
    }
  `,
})

export default navbarStyles
